import {APIClient} from "../base";

const AuthApi = {
    signIn: async (model: {email: string, password: string}) => await APIClient.create('/login', model, true),
    setupFirstLogin: async (model: any) => await APIClient.create('/user/first-login', model, true),
}

export default AuthApi;
